var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage01Layer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 554",
    style: {
      enableBackground: "new 0 0 750 554"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{opacity:.52;fill:#3abece;enable-background:new}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.5 36c133.1.0 241 107.9 241 241s-107.9 240.9-241 240.9C164.4 517.9 56.6 410 56.6 277 56.6 143.9 164.4 36 297.5 36M111 277c0 103 83.5 186.4 186.5 186.4S483.9 379.9 483.9 277c0-103-83.5-186.5-186.4-186.5C194.5 90.5 111 173.9 111 277M204.2 239.4c7.2 15.4 22.8 26 40.8 26 24.9.0 45.1-20.2 45.1-45.1.0-16.9-9.3-31.6-23.2-39.3v0c9.7-3.1 19.9-4.7 30.6-4.7 55.5.0 100.6 45 100.6 100.6.0 55.5-45.1 100.6-100.6 100.6s-100.6-45-100.6-100.6C196.9 263.7 199.5 251 204.2 239.4v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage01Layer2);
export default __webpack_public_path__ + "static/media/image-01-layer-2.2941e51b3b4b4e1e17f75f9695b0562c.svg";
export { ForwardRef as ReactComponent };